import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/electrical';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-tech px-4 py-4 sm:py-6" data-id="element-42" data-mp="1hd1mpvzm93yg">
      <div className="mx-auto max-w-3xl" data-id="element-43" data-mp="1hduloasc2p61">
        <h2 className="text-center text-lg leading-tight text-navy sm:text-3xl" data-id="element-44" data-mp="1cf05zhpnxgq5">
          FREQUENTLY ASKED QUESTIONS
        </h2>

        <ul className="mt-2 divide-y divide-navy/10 overflow-hidden rounded-lg border border-navy/10 bg-white" data-id="element-45" data-mp="2a0xjf0p6qvv8">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.q} data-id="element-46" data-mp="202hqqtaifejm" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-3 py-2 text-left" data-id="element-47" data-mp="205vpzsnvn7mu">
                  <span className="font-head text-[13px] font-bold text-navy sm:text-[15px]" data-id="element-48" data-mp="johr7jfktqww">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`h-4 w-4 shrink-0 text-navy transition-transform duration-150 ease-soft ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-49" data-mp="1pncvxrgsqyb8" />
                </button>
                {isOpen && <p className="px-3 pb-2 text-[13px] font-medium leading-snug text-carbon/80" data-id="element-50" data-mp="11wgwc863mytf">
                    {faq.a}
                  </p>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}